import { FlowController } from '../flow/flowController';

export function setupBranchQuestion(
  flow: FlowController,
  afterBranchStep: number,
  onBranchChange?: (value: 'a' | 'b' | null) => void
): void {
  const optionA = document.getElementById('option-a') as HTMLInputElement | null;
  const optionB = document.getElementById('option-b') as HTMLInputElement | null;
  const questionContinue = document.getElementById('question-continue') as HTMLButtonElement | null;

  const optionABlock = document.querySelector('.option-a-checked') as HTMLElement | null;
  const optionBBlock = document.querySelector('.option-b-checked') as HTMLElement | null;

  let selectedBranch: 'a' | 'b' | null = null;

  if (!optionA || !optionB || !questionContinue) return;

  optionA.checked = false;
  optionB.checked = false;

  optionA.addEventListener('change', () => {
    if (optionA.checked) {
      selectedBranch = 'a';
      optionB.checked = false;
    } else if (optionB.checked) {
      selectedBranch = 'b';
    } else {
      selectedBranch = null;
    }

    onBranchChange?.(selectedBranch);
  });

  optionB.addEventListener('change', () => {
    if (optionB.checked) {
      selectedBranch = 'b';
      optionA.checked = false;
    } else if (optionA.checked) {
      selectedBranch = 'a';
    } else {
      selectedBranch = null;
    }

    onBranchChange?.(selectedBranch);
  });

  questionContinue.addEventListener('click', (event) => {
    event.preventDefault();

    if (!selectedBranch) return;

    optionABlock?.classList.add('hidden');
    optionBBlock?.classList.add('hidden');

    if (selectedBranch === 'a') {
      optionABlock?.classList.remove('hidden');
    }

    if (selectedBranch === 'b') {
      optionBBlock?.classList.remove('hidden');
    }

    flow.showStep(afterBranchStep);
  });
}